import { useState }             from 'react';

import useOnClickOutside        from '../../hooks/useOnClickOutside.js';

function useSelect(props, ref) {
    const {
        onChange
    } = props;

    const [ isOpen, setOpen ] = useState(false);

    useOnClickOutside(ref, handleClose)

    function handleOpen() {
        setOpen(true)
    }

    function handleClose() {
        setOpen(false)
    }

    function handleChange(value) {
        return () => {
            if (onChange) onChange(value);
            handleClose();
        }
    }

    return {
        isOpen,
        handleOpen,
        handleClose,
        handleChange
    };
}

export default useSelect;
